import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomersBaseModule } from '@app/customers-base';
import { FaqsModule } from '../faq/faqs.module';
import { SharedModule } from '../shared/shared.module';
import { ProfileComponent } from './components/profile/profile.component';
import { ProfilesRoutingModule } from './profile-routing.module';

const DECLARATION = [
	ProfileComponent
];

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		CustomersBaseModule,
		FaqsModule,
		ProfilesRoutingModule
	],
	declarations: [DECLARATION]
})
export class ProfileModule { }
